import * as React from 'react';
import { Image, Text, Box, TextButton } from 'wix-style-react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Confirm } from 'wix-ui-icons-common';
import { DataHooks } from '@src/constants/data-hooks';

import unpublished from './unpublished.svg';
import { AppContext } from '@src/context/store';
import { getKBLinks } from '@src/context/selectors/ui-settings';

const UnpublishedStateComponent = ({ t }: InjectedTranslateProps) => {
  const store = React.useContext(AppContext);
  const onLearnMoreClick = () => window.open(getKBLinks(store).PublishYourSite, '_blank');

  const confirmBox = (text: string) => (
    <Box paddingBottom="12px">
      <Box paddingRight="6px">
        <Confirm size="18px" />
      </Box>
      <Box>
        <Text size="small" weight="normal">
          {text}
        </Text>
      </Box>
    </Box>
  );

  return (
    <Box dataHook={DataHooks.UnpublishedStateContainer} align="center" verticalAlign="middle">
      <Box align="center" direction="vertical" verticalAlign="middle" padding="24px 29px 27px">
        <Box align="center" verticalAlign="middle" width={282}>
          <Box padding={2}>
            <Image src={unpublished} style={{ backgroundColor: 'transparent' }} />
          </Box>
        </Box>
        <Box direction="vertical" align="center">
          <Text weight="bold">{t('unpublished.title')}</Text>
          <Text weight="thin" secondary>
            {t('unpublished.subtitle.text')}{' '}
            <TextButton onClick={onLearnMoreClick}>{t('unpublished.subtitle.learn-more')}</TextButton>
          </Text>
        </Box>
        <Box align="left" direction="vertical" width="100%" paddingTop="24px">
          {confirmBox(t('unpublished.item-1'))}
          {confirmBox(t('unpublished.item-2'))}
          {confirmBox(t('unpublished.item-3'))}
        </Box>
      </Box>
    </Box>
  );
};

export const UnpublishedState = translate()(UnpublishedStateComponent);
